import { apiRequest } from '@scc/lib'
import type { ScorecardReviewRepository } from '@/data/repositories/types'
import type { ScorecardMetricKey } from '@/modules/scorecards/catalog'
import type { ScorecardConfig, WeeklyReview, WeeklyReviewInput } from '@/modules/scorecards/review-types'

/** Scorecard config and weekly reviews live under the store, next to its plans. */
const base = (agencyId: number, storeId: number) =>
  `/agencies/${agencyId}/stores/${storeId}/scorecard`

export function createApiScorecardReviewRepository(): ScorecardReviewRepository {
  return {
    getConfig: (agencyId, storeId) => apiRequest<ScorecardConfig>(`${base(agencyId, storeId)}/config`),
    setConfig: (agencyId, storeId, metrics: ScorecardMetricKey[]) =>
      apiRequest<ScorecardConfig>(`${base(agencyId, storeId)}/config`, { method: 'PUT', body: { metrics } }),
    getReview: (agencyId, storeId, weekStarting) =>
      apiRequest<WeeklyReview | null>(`${base(agencyId, storeId)}/reviews/${encodeURIComponent(weekStarting)}`),
    upsertReview: (agencyId, storeId, weekStarting, input: WeeklyReviewInput) =>
      apiRequest<WeeklyReview>(`${base(agencyId, storeId)}/reviews/${encodeURIComponent(weekStarting)}`, {
        method: 'PUT',
        body: input,
      }),
  }
}
